import { render, staticRenderFns } from "./leaderApproval2.vue?vue&type=template&id=e230acc0&scoped=true"
import script from "./leaderApproval2.vue?vue&type=script&lang=js"
export * from "./leaderApproval2.vue?vue&type=script&lang=js"
import style0 from "./leaderApproval2.vue?vue&type=style&index=0&id=e230acc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e230acc0",
  null
  
)

export default component.exports